import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { Button, Input, Message } from "../../../BP2Components";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import IntlMessages from "@util/IntlMessages";
import "../AdvertisementList/advertisementListSettings.less";
import { setWidgetInSheetParams } from "../../../../appRedux/actions/Boards";

const { Option } = Select;

const ProjectSummarySettings = ({ value, elements }) => {
   const dispatch = useDispatch();
   const intl = useIntl();
   const [settings, setSettings] = useState({
      ...value,
   });
   const [validOptions, setValidOptions] = useState();
   const isV3 = value.formId?.length > 10;
   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };
   const selectFields = [
      { key: "projectName", label: "projectSummary.projectName" },
      { key: "progressInProject", label: "projectSummary.progress_in_completing_the_project" },
      { key: "startProject", label: "projectSummary.start_of_the_project" },
      { key: "endProject", label: "projectSummary.end_of_the_project" },
      { key: "hourlyBudget", label: "projectSummary.hourly_budget" },
      { key: "hoursUsed", label: "projectSummary.hours_used" },
   ];

   const normalizeLabel = (text) =>
      String(text ?? "")
         .trim()
         .toLowerCase();

   const filterSelectFieldsByLabels = (selectFields, validOptions) => {
      const availableLabels = new Set(
         (validOptions ?? []).map((item) => item?.value ?? item?.id?.label).map(normalizeLabel),
      );

      return (selectFields ?? []).filter(({ label }) => {
         const translatedLabel = intl.formatMessage({ id: label });
         return availableLabels.has(normalizeLabel(translatedLabel));
      });
   };

   const filteredSelectFields = filterSelectFieldsByLabels(selectFields, validOptions);

   const options = (validOptions ?? []).map((opt) => (
      <Option value={opt.id} key={opt.id}>
         {opt.value}
      </Option>
   ));

   const handleChange = (e, name) => {
      setSettings({ ...settings, [name]: e.target.value === "-" ? null : e.target.value });
   };

   const handleChangeSelect = (value, name) => {
      setSettings({ ...settings, [name]: value === "-" ? null : value });
   };

   useEffect(() => {
      if (!elements) return;
      if (isV3) {
         const options = Object.keys(elements)
            .filter(
               (element) =>
                  !elements[element]?.decorators[0]?.properties.hide &&
                  elements[element]?.value?.originalValue != null,
            )
            .map((key) => ({
               id: key,
               value: elements[key].label,
            }));
         setValidOptions([...options]);
      } else {
         setValidOptions([
            ...Object.keys(elements)
               .filter(
                  (key) =>
                     elements[key]?.type !== "sql" &&
                     elements[key]?.type !== "dict" &&
                     elements[key].hidden !== "1",
               )
               .map((key) => ({
                  id: key,
                  value: elements[key].bizDescription,
               })),
         ]);
      }
   }, [elements]);

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div className="widget-settings__inner">
                  <label className="widget-settings__inner__label" key="formId">
                     <IntlMessages id="settings.formId" />:
                     <Input
                        onChange={(e) => handleChange(e, "formId")}
                        defaultValue={settings?.formId}
                        name="formId"
                        id="formId"
                        type="string"
                     ></Input>
                  </label>
                  <label className="widget-settings__inner__label" key="recordId">
                     <IntlMessages id="settings.recordId" />:
                     <Input
                        onChange={(e) => handleChange(e, "recordId")}
                        defaultValue={settings?.recordId}
                        name="recordId"
                        id="recordId"
                        type="string"
                     ></Input>
                  </label>
                  {filteredSelectFields.map(({ key, label }) => (
                     <label className="widget-settings__inner__label" key={key}>
                        <IntlMessages id={label} />:
                        <Select
                           defaultValue={settings?.[key] ?? undefined}
                           onChange={(e) => handleChangeSelect(e, key)}
                        >
                           {options}
                        </Select>
                     </label>
                  ))}
               </div>
               <Button key="btn" buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};
export default ProjectSummarySettings;
